import { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import styled from '@emotion/styled';
import * as Sentry from '@sentry/react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import * as $session from '@/auth/session';
import * as $sessionHttp from '@/auth/session-http';
import { Spinner } from '@trinity/chat-components/components/presentation/Spinner.js';
import { actions } from '@/store/actions';
import { config } from '@/config';
import { getAuthProvider } from '@/auth/auth-provider';

export const LogoutScreen = () => {
  const dispatch = useDispatch();
  const queryClient = useQueryClient();
  const navigate = useNavigate();

  const { mutateAsync: logoutAsync } = useMutation({
    mutationFn: () => {
      return $sessionHttp.logout();
    },
    onSuccess: res => {
      // Check if user logged in via Trinity Edge
      const lastLoginStrategy = $session.getLastLoginStrategy();

      console.log('Last login strategy:', lastLoginStrategy);

      if (lastLoginStrategy?.strategy === 'enterprise' && lastLoginStrategy?.identifier === 'trinity-edge') {
        console.log('User logged in via Trinity Edge, redirecting to Trinity Edge logout.');
        getAuthProvider().logout(false);
        window.location.replace(config().TRINITY_EDGE_BASE_URL);
        return;
      }

      console.log('User logged out, dispatching logout action.');

      Sentry.setUser(null);
      dispatch(actions.userLoggedOutAction());
      queryClient.cancelQueries()
        .then(() => {
          queryClient.clear();
        });

      if (!res.wasAuthenticated) {
        console.log('User was not authenticated, redirecting to home.');
        return navigate('/', { replace: true });
      }

      const redirectPath = '/_login';
      navigate(redirectPath, { replace: true });
    },
  });

  useEffect(() => {
    setTimeout(() => {
      logoutAsync();
    }, 500);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <Root>
      <Spinner />
    </Root>
  );
};

const Root = styled.div({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  alignItems: 'center',
  height: `calc(100vh - var(--navbar-height))`,
});